module.exports = __webpack_public_path__ + "media/images/reduire-mon-anxiete-908b9db8faec3a446bc6d92babd63e42.svg";